module.exports = __webpack_public_path__ + "static/media/DaciaBlock-Variable.ec185e58.woff";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/dacia-block/DaciaBlock-Variable.woff
// module id = 660
// module chunks = 0